"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEAdvertisement = void 0;

var _react = _interopRequireDefault(require("react"));

var _FAEText = require("../FAEText/FAEText");

var _FAEContainer = require("../FAEContainer/FAEContainer");

var _FAELoading = require("../FAELoading/FAELoading");

require("./FAEAdvertisement.scss");

const _excluded = ["primary", "image1", "image2", "playStoreImage", "appleStoreImage", "className", "justify", "align", "loading", "loaderProps"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAEAdvertisement = _ref => {
  let {
    primary,
    image1,
    image2,
    playStoreImage,
    appleStoreImage,
    className = "",
    justify,
    align,
    loading,
    loaderProps
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_FAEContainer.FAEContainer, {
    justify: justify,
    align: align
  }, loading ? /*#__PURE__*/_react.default.createElement(_FAELoading.FAELoading, loaderProps) : /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "fae--advertisement ".concat(className)
  }, rest), primary ? /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--advertisement-primary-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--advertisement-primary-wrapper"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image1,
    alt: "Advertisement Mobile",
    className: "ad-images"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--advertisement-primary-text"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    light: true
  }, "Want all the ", /*#__PURE__*/_react.default.createElement("b", null, "Services"), " at your fingertips"), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    light: true
  }, "Download the ", /*#__PURE__*/_react.default.createElement("b", null, "Expert"), " app Now")), /*#__PURE__*/_react.default.createElement("img", {
    src: image2,
    alt: "Advertisement Girl",
    width: "180px",
    className: "ad-images"
  }))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--advertisement-default-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--advertisement-default-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    style: {
      fontSize: "20px"
    }
  }, "Do You Need All ", /*#__PURE__*/_react.default.createElement("b", null, "Services")), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    secondary: true,
    style: {
      fontSize: "20px"
    },
    light: true
  }, "at your Fingertips")), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--advertisement-action-buttons-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    style: {
      fontSize: "14px"
    }
  }, "Download the ", /*#__PURE__*/_react.default.createElement("b", {
    className: "red-text"
  }, "Expert App"), " Now"), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--advertisement-default-app-download-icons"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://play.google.com/store/apps/details?id=com.findanexpert",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: playStoreImage,
    alt: "Google Play",
    className: "google-play-icon"
  })), /*#__PURE__*/_react.default.createElement("a", {
    href: "https://apps.apple.com/us/app/find-an-expert/id1468090965?ls=1",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: appleStoreImage,
    alt: "Apple Store",
    className: "apple-store-icon"
  }))))))));
};

exports.FAEAdvertisement = FAEAdvertisement;